<template>
  <div v-if="guideTipsStore.isGuideTipsBarVisible" class="guide-tips-bar-wrap">
    <div class="guide-tips-bar-spacer" aria-hidden="true" />
    <div class="guide-tips-bar" role="banner">
      <div class="guide-tips-bar__inner">
        <p class="guide-tips-bar__text" v-html="tipsData!.content"></p>
        <button type="button" class="guide-tips-bar__cta" @click="onCtaClick">
          {{ ctaLabel }}
        </button>
      </div>
      <button
        type="button"
        class="guide-tips-bar__close"
        aria-label="关闭引导条"
        @click="guideTipsStore.dismiss"
      >
        <span class="guide-tips-bar__close-icon" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, onMounted } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDialogStore } from '@/stores/dialog'
  import { useGuideTipsBarStore } from '@/stores/guideTipsBar'

  defineOptions({ name: 'GuideTipsBar' })

  const dialogStore = useDialogStore()
  const guideTipsStore = useGuideTipsBarStore()
  const { tipsData } = storeToRefs(guideTipsStore)

  const ctaLabel = computed(() => tipsData.value?.buttonText?.trim() || '下载 App')

  const isValidWebJumpUrl = (url: string) => {
    const u = url.trim()
    if (!u || u === '-') return false
    return (
      u.startsWith('http://') || u.startsWith('https://') || u.startsWith('/') || u.startsWith('//')
    )
  }

  const onCtaClick = () => {
    const d = tipsData.value
    if (!d) return

    const webUrl = (d.webButtonJumpUrl || '').trim()
    if (isValidWebJumpUrl(webUrl)) {
      if (webUrl.startsWith('//')) {
        window.location.href = `${window.location.protocol}${webUrl}`
      } else {
        window.location.href = webUrl
      }
      return
    }

    dialogStore.openDownloadAppDialog()
  }

  onMounted(() => {
    guideTipsStore.fetchGuideTips()
  })
</script>

<style scoped lang="stylus">
  @import './index.styl'
</style>
